import { useCallback } from 'react';
import useWfApi from './axios/useWfApi';

export interface WfLoginRequestBody {
  username: string;
  password: string;
}

function useWfSecurityRepo() {
  const { post } = useWfApi();

  const postLoginRequest = useCallback(
    async (body: WfLoginRequestBody) =>
      await post<void>('/api/wf/login', body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }),
    [post]
  );

  const postLogoutRequest = useCallback(async () => {
    try {
      return await post<void>('/api/wf/logout');
    } catch (error) {
      console.log(error);
      return;
    }
  }, [post]);

  return {
    postLoginRequest,
    postLogoutRequest,
  };
}

export default useWfSecurityRepo;
